import Vue from 'vue';
import Vuex from 'vuex';
import flag from './flag';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    flag:{...flag}
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js